module.exports = __webpack_public_path__ + "bootleggers_coffee_font01.jpg?b535b8e814e4b601c00f09b1ba99d9f9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_font01.jpg
// module id = 35
// module chunks = 0